import React from 'react';
import { Route, Switch, Redirect } from 'react-router';
import { useSelector } from 'react-redux';

// Faqs
// ==========================================
// Faqs: Common
import './faqs.scss';
import Navbar from './_common/navbar';
import Footer from './_common/footer';

// Faqs: Views
import {Faq} from './faq';

export const Faqs = () => {

    return (
		<div className="layout">
            <h1 className="sr-only visually-hidden">Assist@</h1>
			<Navbar />
            <Faq />
            <Footer />
		</div>
    )
}